import {
  ESortTypes,
  ISortTypes,
  EFilterTypeField,
  TTableColumns,
  TSelectedFilterValues,
  TSelectedFilterValue,
} from '@/components/table/types';
import { SEPARATOR_URL_FILTER_VALUES } from '@/configs/tableConfigs';
import { TDictionary, TDropDownItem, TDropDownList } from '@/types';
import {
  deleteUrlParams,
  TUrlSearchParam,
  TUrlSearchParams,
} from '@/helpers/urlParamsHelpers';
import { userCanByRole } from '@/helpers/authHelpers';

// Types

// Functions
export const tableSortTypes = (): ISortTypes => {
  return {
    asc: ESortTypes.ASC,
    desc: ESortTypes.DESC,
    none: ESortTypes.NONE,
  };
};

export const changeSortType = (sortType: string): string => {
  switch (sortType) {
    case ESortTypes.NONE:
      return ESortTypes.ASC;
    case ESortTypes.ASC:
      return ESortTypes.DESC;
    case ESortTypes.DESC:
      return ESortTypes.NONE;
    default:
      return ESortTypes.NONE;
  }
};

export const changeSortParam = (sortParam: string): string => {
  if (sortParam === '') {
    return sortParam;
  } else if (sortParam.charAt(0) === '-') {
    return '';
  } else {
    return '-' + sortParam;
  }
};

export const getSortType = (sortParam: string | null): string => {
  if (!sortParam) {
    return ESortTypes.NONE;
  } else if (sortParam.charAt(0) === '-') {
    return ESortTypes.DESC;
  } else {
    return ESortTypes.ASC;
  }
};

export const getSortParam = (sortType: string, sortColumn: string): string => {
  switch (sortType) {
    case ESortTypes.ASC:
      return sortColumn;
    case ESortTypes.DESC:
      return '-' + sortColumn;
    case ESortTypes.NONE:
      return '';
    default:
      return '';
  }
};

export const getSortColumn = (sortParam: string): string => {
  if (sortParam === '') {
    return '';
  } else if (sortParam.charAt(0) === '-') {
    return sortParam.slice(1);
  } else {
    return sortParam;
  }
};

export const formatingColumns = (columns: TTableColumns): TTableColumns => {
  const newColumns = [] as TTableColumns;

  try {
    for (const column of columns) {
      if (column.visible === undefined) {
        column.visible = true;
      }

      if (column.filterTypeField === undefined) {
        column.filterTypeField = EFilterTypeField.list;
      }

      if (column.role !== undefined) {
        if (userCanByRole(column.role)) {
          column.useInFilter = true;
        } else {
          column.useInFilter = false;
        }
      }

      if (column.useSort === undefined) {
        column.useSort = true;
      }

      if (column?.useInFilter) {
        column.filterValues = [];
      }

      newColumns.push(column);
    }
  } catch (err) {
    console.error('formatingColumns: ', err);
  }

  return newColumns;
};

export const sortModalListItems = (
  list: Array<any>,
  sortParams: Array<string>
): TDropDownList => {
  const [label, value] = sortParams;
  const sortedList: TDropDownList = [];
  let newItem: TDropDownItem;

  try {
    for (const item of list) {
      newItem = {
        label: item[label],
        value: item[value],
      };

      sortedList.push(newItem);
    }
  } catch (err) {
    console.error('sortModalListItems: ', err);
  }

  return sortedList;
};

export const createDataToUrlFilters = (
  values: TSelectedFilterValues,
  filter: string
): TUrlSearchParams => {
  const urlSearchParams = [] as TUrlSearchParams;
  let urlParam = {} as TUrlSearchParam;

  try {
    deleteUrlParams(filter);

    for (const item of values) {
      urlParam = {
        param: filter,
        value: `${item.field}${SEPARATOR_URL_FILTER_VALUES}${item.value}`,
      };

      urlSearchParams.push(urlParam);
    }
  } catch (err) {
    console.error('createDateToUrlFilters: ', err);
  }

  return urlSearchParams;
};

export const parceDataFromUrlFilters = (
  query: TDictionary<string>,
  filter: string
): TSelectedFilterValues => {
  const filterValues = [] as TSelectedFilterValues;
  let tempValue = {} as TSelectedFilterValue;

  try {
    const addFilterValues = (item: string) => {
      const [field, value] = item.split(SEPARATOR_URL_FILTER_VALUES);

      tempValue = {
        name: '',
        field,
        label: '',
        value,
      };

      filterValues.push(tempValue);
    };

    if (Array.isArray(query[filter])) {
      for (const item of query[filter]) {
        addFilterValues(item);
      }
    } else {
      if (query[filter]) {
        addFilterValues(query[filter]);
      }
    }
  } catch (err) {
    console.error('parceDataFromUrlFilters: ', err);
  }

  return filterValues;
};

export const setColumnMultipleFromFilterMultiple = (
  columns: TTableColumns,
  multiple: boolean
): TTableColumns => {
  let tempFilterValue = null as TDropDownList | null;

  try {
    for (const column of columns) {
      column.multiple = multiple;

      if (!multiple) {
        if (column.filterValues?.length) {
          column.filterValues = [column.filterValues[0]];
          tempFilterValue = column.filterValues;
        }
      }
    }

    if (!multiple) {
      for (const column of columns) {
        if (column.filterValues?.length) {
          if (column.filterValues !== tempFilterValue) {
            column.filterValues = [];
          }
        }
      }
    }
  } catch (err) {
    console.error('setColumnMultipleFromFilterMultiple: ', err);
  }

  return columns;
};
